class NvTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => {
        const last = this.tabs.length - 1;
        let n = null;
        if (e.key === 'ArrowRight') n = i === last ? 0 : i + 1;
        if (e.key === 'ArrowLeft') n = i === 0 ? last : i - 1;
        if (n === null) return;
        e.preventDefault();
        this.select(n);
        this.tabs[n].focus();
      });
    });
    this.select(0);
  }
  select(index) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (this.panels[i]) this.panels[i].hidden = !on;
    });
  }
}
if (!customElements.get('nv-tabs')) customElements.define('nv-tabs', NvTabs);
